module.exports = __webpack_public_path__ + "img/tertiary_6x4.25601938.svg";